import ProductList from '@/components/ProductList';
import React from 'react';
import show from '../Drawer/show';
import './style.scss';

export type OrderSelectInfo = {
  order_id?: number;
  inboundOrderSn: string;
  isReturned: boolean;
  dialogueParms?: any;
  text?: string;
  isClose?: boolean;
}

interface WaitOrderSelectProps {
  userTypeLabel: string;
}

export default function waitOrderSelect(props: WaitOrderSelectProps): Promise<OrderSelectInfo> {
  const { userTypeLabel } = props;
  return new Promise((resolve) => {
    const instance = show({
      height: 'initial',
      children: (
        <div className="order-drawer">
          <ProductList
            isInboundOrder
            onClose={() => {
              resolve({ inboundOrderSn: '', isReturned: false, isClose: true });
              instance.destroy();
            }}
            onSubmit={(props: {oderSn: string, dialogueParms?: any, text?: string}) => {
              const { oderSn, dialogueParms, text } = props;
              resolve({ inboundOrderSn: oderSn, isReturned: false, dialogueParms, text });
              instance.destroy();
            }}
            onReturn={() => {
              resolve({ inboundOrderSn: '', isReturned: true, isClose: true });
              instance.destroy();
            }}
            userTypeLabel={userTypeLabel}
          />
        </div>
      ),
      onClose: () => {
        resolve({ inboundOrderSn: '', isReturned: false, isClose: true });
        instance.destroy();
      },
    });
  });
}
